(function () {
  'use strict';

  /* @ngdoc object
   * @name mapPairingGroups
   * @description
   *
   */
  angular
    .module('mapPairingGroups', [
      'ui.router'
    ]);
}());
